/*
 * Copyright (c) 2023 Class Technologies Inc. All rights reserved.
 */

const copyToClipboardViaApi = async (text: string): Promise<void> => (navigator.clipboard.writeText(text));

const copyToClipboardViaCopyCommand = (text: string): void => {
    const input = document.createElement('input');
    input.value = text;
    document.body.appendChild(input);
    try {
        input.select();
        document.execCommand('copy');
    } finally {
        input.remove();
    }
};

/**
 * In some cases, e.g. in iFrames, the {@code navigator.clipboard} isn't available. In such cases
 * a fallback to an alternative solution is necessary. This method should encapsulate fallbacks to
 * treat this problem.
 *
 * @param text the string to copy to clipboard
 */
// export const copyToClipboard = async (navigator: Navigator, document: Document, text: string): Promise<void> => {
export const copyToClipboard = async (text: string): Promise<void> => {
    // Clipboard API isn't available
    if (!navigator.clipboard) {
        copyToClipboardViaCopyCommand(text);
        return Promise.resolve();
    }
    // Try to use Clipboard API
    try {
        await copyToClipboardViaApi(text);
    } catch (e) {
        copyToClipboardViaCopyCommand(text);
    }
    return Promise.resolve();
};
